jQuery(document).ready(function() {
  var slideCount = jQuery('.features.features-slider').hasClass('count-up') ? 3 : 4;

  jQuery('.features.features-slider').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: slideCount,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    autoplaySpeed: 4000,
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3
            }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 501,
          settings: {
            slidesToShow: 1,
          }
        }
    ]
  });
});

